const defaultTagData = {
	shareTitle: 'SBSplayon | SBS',
	shareDescription:
		'SBS홈페이지의 새로운 브랜드, SBS play! 실시간라이브와 10만여편의 VOD 무료 즐기기',
	shareImageUrl: 'https://program-image.cloud.sbs.co.kr/og/2025/sbs_home.png',
	currentUrl: 'https://www.sbs.co.kr',
	keywords:
		'SBS,에스비에스,뉸,sbs온에어,sbs실시간,www.sbs.co.kr,sbs.co.kr,지상파,VOD 무료,SBS 드라마 무료,sbskorea,sbstv,sbs편성표,sbs 韓国,sbs korean,서울방송,Seoul Broadcasting System',
};

export default { ...defaultTagData };